import "./NumberInput.scss";
import React, { useEffect, useState } from "react";

const NumberInput = ({
  quantity,
  add,
  remove,
}: {
  quantity?: number;
  add: () => void;
  remove: () => void;
}) => {
  const [value, setValue] = useState<number>(quantity ?? 0);

  const increment = () => {
    add();
    setValue((prev) => prev + 1);
  };
  const decrement = () => {
    remove();
    setValue((prev) => prev - 1);
  };

  useEffect(() => {
    quantity !== value && setValue(value);
  }, [quantity, value, setValue]);

  return (
    <div className="number-input">
      <button className="decrement" onClick={decrement} disabled={value === 0}>
        -
      </button>
      {/* <input type="number" value={value} readOnly /> */}
      <span>{value}</span>
      <button className="increment" onClick={increment}>
        +
      </button>
    </div>
  );
};

export default NumberInput;
